import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!
  const _component_LoadingMask = _resolveComponent("LoadingMask")!
  const _component_FileUploadProgress = _resolveComponent("FileUploadProgress")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["base-app windows", _ctx.baseInfo.system])
    }, [
      _createVNode(_component_a_config_provider, {
        locale: _ctx.baseInfo.locale
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }, 8, ["locale"])
    ], 2),
    _createVNode(_component_LoadingMask),
    _createVNode(_component_FileUploadProgress)
  ], 64))
}